const PageLoader = () => (
  <div className="fixed inset-0 bg-[#060A0F] flex flex-col items-center justify-center z-[9999]">

    {/* Logo + wordmark */}
    <div className="flex items-center gap-3">
      <img src="/NN-logo-1.svg" alt="Nordic Numbers" className="h-10 w-auto opacity-90" />
      <div className="flex flex-col leading-none gap-[3px]">
        <span className="font-bold text-white tracking-tight text-[1.1rem]">Nordic</span>
        <span className="font-bold text-blue-400 tracking-tight text-[1.1rem]">Numbers</span>
      </div>
    </div>

    {/* Sweeping progress bar — fixed at bottom */}
    <div className="fixed bottom-0 left-0 right-0 h-[2px] bg-white/[0.04] overflow-hidden">
      <div
        className="h-full w-48 bg-gradient-to-r from-transparent via-blue-500 to-transparent"
        style={{ animation: 'nn-progress 1.5s ease-in-out infinite' }}
      />
    </div>

  </div>
);

export default PageLoader;
